import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=580021bc&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('580021bc')) {
      api.createRecord('580021bc', component.options)
    } else {
      api.reload('580021bc', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=580021bc&", function () {
      api.rerender('580021bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vwO1T0MersFh/JS/comp/ImgFallback.vue"
export default component.exports